import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogDescription 
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X, Blocks, Download, ExternalLink } from "lucide-react";
import { useSonas } from '../SonasContext';

const PLUGIN_URL = "https://create.roblox.com/store/asset/95778976602783/Architect";

const PluginInstallModal = () => {
  const { isInstallModalOpen, setIsInstallModalOpen, setPluginConnected } = useSonas();

  const handleInstall = () => {
    // Open the Roblox store link
    window.open(PLUGIN_URL, '_blank');
    
    // Optimistically update state
    if (typeof setPluginConnected === 'function') {
      setPluginConnected(true);
    }
    setIsInstallModalOpen(false);
  };

  return (
    <Dialog open={isInstallModalOpen} onOpenChange={setIsInstallModalOpen}>
      <DialogContent className="glass-surface border-sonas-border max-w-sm p-0 overflow-hidden rounded-[32px] shadow-2xl">
        <div className="p-8 text-center space-y-6">
          <div className="flex justify-center">
            <div className="h-16 w-16 rounded-[24px] bg-sonas-accent/10 flex items-center justify-center border border-sonas-accent/20 animate-pulse">
              <Blocks className="h-8 w-8 text-sonas-accent" />
            </div>
          </div>
          
          <DialogHeader className="space-y-2">
            <DialogTitle className="text-2xl font-syne font-bold text-center">
              Bridge the Grid
            </DialogTitle>
            <DialogDescription className="text-sm text-sonas-muted leading-relaxed">
              To inject scripts directly into Roblox Studio, you need the official **Architect** companion plugin.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 pt-2">
            <Button 
              className="w-full h-14 bg-sonas-accent hover:bg-sonas-accent/90 text-sonas-bg font-bold rounded-2xl shadow-lg shadow-sonas-accent/20 gap-2 text-base transition-all active:scale-[0.98]"
              onClick={handleInstall}
            >
              <Download size={18} /> Install From Store
            </Button>
            
            <button 
              className="text-[10px] font-bold uppercase tracking-[0.2em] text-sonas-dim hover:text-sonas-text transition-colors flex items-center justify-center gap-2 mx-auto"
              onClick={() => setIsInstallModalOpen(false)}
            >
              Skip for now
            </button>
          </div>

          <div className="pt-4 border-t border-white/5">
             <p className="text-[9px] text-sonas-dim leading-relaxed italic">
               * Requires Roblox Studio to be open for real-time synchronization.
             </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PluginInstallModal;